<template>
  <div class="nc-jumbotron">
    <p>
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'JumbotronView',

  props: {
    message: {
      type:     String,
      required: true,
    },
  },

};
</script>

<style scoped lang="scss">
    .nc-jumbotron {
        text-align: center;
        padding: 80px 0px;
        font: normal normal 600 30px/42px Open Sans;
        background-image: url('../../../assets/images/hero-BG.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
    }
</style>
